import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListBusiness from "../../../../components/@business/ListBusiness";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function BusinessPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListBusiness
                routeType={routeType}
            />
        </SettingFrame>
    )
}